module.exports = __webpack_public_path__ + "img/score.35476949.svg";